<template>
  <div v-if="show" class="flex items-start justify-between px-4 py-4 sm:px-8 mdl-color--info mdl-color-text--white">
    <div class="flex flex-col items-start gap-y-4 w-11/12">
      <span>
        {{ message }}
      </span>
      <div class="flex items-center gap-4">
        <slot />

        <MdlButton
          v-if="isMobile"
          icon="arrow_forward"
          primary
          raised
          inverted
          :data-qa-id="pendo('confirmRegionBanner')"
          @click="emit('change')"
        />

        <MdlButton v-else primary raised inverted :data-qa-id="pendo('confirmRegionBanner')" @click="emit('change')">
          {{ trans('Confirm') }}
        </MdlButton>
      </div>
    </div>

    <div class="w-1/12 flex justify-end">
      <MdlButton icon="close" small :data-qa-id="pendo('dismissRegionBanner')" @click="emit('dismiss')" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { pendoLabel as pendo } from '@/munio/utils'
import { trans } from '@/munio/i18n/index.js'
import MdlButton from '@component/mdl/Button.vue'

defineProps<{
  show: boolean
  isMobile: boolean
  message: string
}>()

const emit = defineEmits<{
  (e: 'change'): void
  (e: 'dismiss'): void
}>()
</script>
